import DynamicForm from "../common/DynamicForm";
import { useEffect, useState } from "react";
import EndEndorment from "./EndEndorment";

const SecondarySystemForm = (props: any) => {
  const { register, control, errors, watch, setValue, isView } = props;

  const [showPassword, setShowPassword] = useState(false);
  const [temp, setTemp] = useState(0);

  const fieldsJson = [
    {
      groupName: "secondary_system",
      title: "Secondary System",
      fields: [
        {
          name: "secondary_mode",
          label: "Connection mode",
          size: 12,
          inputType: "radio",
          options: ["SFTP", "API"],
          optionFlex: "row",
          defaultValue: "SFTP",
        },
        {
          name: "secondary_data_format",
          label: "Data Format*",
          size: 4,
          inputType: "dropdown",
          options: [
            { value: "json", label: "JSON" },
            { value: "csv", label: "CSV" },
          ],
        },
        {
          name: "secondary_base_url",
          label: "Base URL",
          size: 4,
          visibility: "false",
        },
        {
          name: "secondary_base_folder_path",
          label: "Base Folder Path",
          size: 4,
        },
        {
          name: "secondary_base_api_path",
          label: "Base API Path",
          size: 4,
          visibility: "false",
        },
        {
          name: "secondary_username",
          label: "Username",
          size: 4,
          autocomplete: "off",
        },
        {
          name: "secondary_password",
          label: "Password",
          size: 4,
          type: showPassword ? "text" : "password",
          autocomplete: "off",
          InputProps: {
            endAdornment: (
              <EndEndorment show={showPassword} setShow={setShowPassword} />
            ),
          },
        },
        {
          name: "secondary_sftp_host",
          label: "SFTP Host",
          size: 4,
          visibility: "true",
        },
        {
          name: "secondary_sftp_port",
          label: "SFTP Port",
          size: 4,
          visibility: "true",
          inputType: "number",
          type: "tel",
        },
        {
          name: "secondary_study_file_id",
          label: "Study File Identifier",
          size: 4,
          visibility: "true",
        },
        {
          name: "secondary_study_json_path",
          label: "Study JSON Path",
          size: 4,
          visibility: "false",
        },
        {
          name: "secondary_mapping_id",
          label: "Mapping Id",
          size: 4,
        },
        {
          name: "secondary_token_url",
          label: "Token URL",
          size: 4,
          visibility: "false",
        },
      ],
    },
  ];
  const [fields, setFields] = useState(fieldsJson);

  const watchMode = watch("secondary_mode");

  useEffect(() => {
    if (watchMode == "API") {
      const temp = fields?.map((item: any) => {
        return {
          ...item,
          fields: item.fields?.map((field: any) => {
            if (
              field.name == "secondary_base_folder_path" ||
              field.name == "secondary_sftp_host" ||
              field.name == "secondary_sftp_port" ||
              field.name == "secondary_study_file_id"
            ) {
              return { ...field, visibility: "false" };
            } else if (
              field.name == "secondary_base_api_path" ||
              field.name == "secondary_study_json_path" ||
              field.name == "secondary_token_url" ||
              field.name == "secondary_base_url"
            ) {
              return { ...field, visibility: "true" };
            } else {
              return field;
            }
          }),
        };
      });
      setValue("secondary_base_folder_path", "");
      setValue("secondary_sftp_host", "");
      setValue("secondary_sftp_port", "");
      setValue("secondary_study_file_id", "");
      setFields(temp);
    }
    if (watchMode == "SFTP") {
      const temp = fields?.map((item: any) => {
        return {
          ...item,
          fields: item.fields?.map((field: any) => {
            if (
              field.name == "secondary_base_folder_path" ||
              field.name == "secondary_sftp_host" ||
              field.name == "secondary_sftp_port" ||
              field.name == "secondary_study_file_id"
            ) {
              return { ...field, visibility: "true" };
            } else if (
              field.name == "secondary_base_api_path" ||
              field.name == "secondary_study_json_path" ||
              field.name == "secondary_token_url" ||
              field.name == "secondary_base_url"
            ) {
              return { ...field, visibility: "false" };
            } else {
              return field;
            }
          }),
        };
      });
      setValue("secondary_base_api_path", "");
      setValue("secondary_study_json_path", "");
      setValue("secondary_token_url", "");
      setValue("secondary_base_url", "");
      setFields(temp);
    }
    setTemp(temp + 1);
  }, [watchMode]);

  useEffect(() => {
    if (!isView) {
      const temp = fields?.map((item: any) => {
        return {
          ...item,
          fields: item.fields?.map((field: any) => {
            if (field.name == "secondary_password") {
              return {
                ...field,
                type: showPassword ? "text" : "password",
                InputProps: {
                  endAdornment: (
                    <EndEndorment
                      show={showPassword}
                      setShow={setShowPassword}
                    />
                  ),
                },
              };
            } else {
              return field;
            }
          }),
        };
      });
      setFields(temp);
    }
  }, [showPassword]);

  return (
    <DynamicForm
      // key={temp}
      fieldsJson={fields}
      errors={errors}
      register={register}
      control={control}
      groups
    />
  );
};

export default SecondarySystemForm;
